export default {
  download: {
    documentTitle: 'Ruta ORS',
    download: 'Descărcați',
    downloadFileName: 'Numele fișierului de descărcare',
    downloadFormat: 'Format de descărcare',
    downloadRoute: 'Ruta de descărcare',
    preparingDownload: 'Pregătirea pentru descărcare ...',
    fileReady: 'Fișier pregătit',
    errorPreparingFile: 'Eroare la pregătirea fișierului',
    standard: 'Standard',
    fileTooBigToBeDownloaded: 'Fișier prea mare pentru a fi descărcat',
  }
}
